<template>
    <b-modal scrollable ref="mdlTeamsystemintegrator" :title="title" centered no-close-on-backdrop no-close-on-esc hide-header-close size="xl" @ok="onOk">
        <div style="height: 100%">
            <div class="sa-flexbox" style="padding-bottom: 20px">
                <div class="sa-flexbox-header">
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Tipo Documento</label>
                            <span class="sa-data">{{ jsonDataFattura.Testata.tipoDocumento }}</span>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Codice Fiscale</label>
                            <span class="sa-data">{{ jsonDataFattura.Testata.codiceFiscale }}</span>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Ragione Sociale</label>
                            <span class="sa-data">{{ jsonDataFattura.Testata.ragioneSociale }}</span>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Città</label>
                            <span class="sa-data">{{ jsonDataFattura.Testata.citta }} ({{ jsonDataFattura.Testata.provincia }})</span>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Cap</label>
                            <span class="sa-data">{{ jsonDataFattura.Testata.cap }}</span>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Indirizzo</label>
                            <span class="sa-data">{{ jsonDataFattura.Testata.indirizzo }}</span>
                        </b-col>
                    </b-row>
                </div>
                <div class="sa-flexbox-body">
                    <div class="b-table-sticky-header">
                        <b-table scrollable head-variant="light" class="sa-b-table" sticky-header ref="table" stacked="lg" striped hover :items="jsonDataFattura.Corpo" :fields="fields" sort-icon-left>
                            <template #cell(index)="row">
                                <span> {{ row.index + 1 }} </span>
                            </template>
                            <template v-slot:cell(articolo)="{ item }">
                                <span>{{ item.descrizione }} ({{ item.codiceArticolo }})</span>
                            </template>
                            <template v-slot:cell(quantita)="{ item }">
                                <span>{{ item.quantita }} ({{ item.unitaMisura }})</span>
                            </template>
                        </b-table>
                    </div>
                </div>
                <div class="sa-flexbox-footer">
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <label class="sa-label-data">Note:</label>
                            <span class="sa-data">{{ jsonData.note }}</span>
                        </b-col>
                        <b-col cols="12" xs="6" sm="6" md="6" lg="6" xl="6" class="sa-padding-left text-left">
                            <label class="sa-label-data">Totale Versato:</label>
                            <span class="sa-data">{{ totaleVersato }}</span>
                        </b-col>
                        <b-col cols="12" xs="6" sm="6" md="6" lg="6" xl="6" class="sa-padding-right text-right">
                            <label class="sa-label-data">Totale:</label>
                            <span class="sa-data">{{ totaleDocuemnto }}</span>
                        </b-col>
                    </b-row>
                </div>
            </div>
        </div>
    </b-modal>
</template>

<script>
import UtilityMixin from "../../utility/UtilityMixin";
export default {
    mixins: [UtilityMixin],
    data() {
        return {
            pathResource: "/teamsystemintegratorresponse",
            title: "Visualizza Fattura",
            id: null,
            jsonData: {},
            totaleDocuemnto: 0,
            totaleVersato: 0,
            jsonDataFattura: { Testata: {}, Corpo: [] },
            fields: [
                {
                    label: "*",
                    key: "index",
                    thStyle: "width: 0.5rem",
                },
                {
                    label: "Articolo",
                    key: "articolo",
                    // thStyle: "width: 0.5rem",
                },
                {
                    label: "Quantita",
                    key: "quantita",
                    thStyle: "width: 5rem",
                },
                {
                    label: "Prezzo Unitario",
                    key: "prezzoUnitario",
                    thStyle: "width: 10rem",
                },
                {
                    label: "Totale",
                    key: "importoTotale",
                    thStyle: "width: 10rem",
                },
            ],
        };
    },
    methods: {
        init(id) {
            let me = this;
            me.id = id;
            me.loadData();
        },
        loadData() {
            let me = this;
            me.$emit("beforeLoadData");
            let link = me.pathResource + "/" + me.id;
            UtilityMixin.methods.loadDataResources(link, null, me.loadDataSuccess, me.loadDataError);
        },
        loadDataSuccess(response) {
            let me = this;
            me.jsonData = response.data.data;
            me.jsonDataFattura = JSON.parse(me.jsonData.body);
            me.$emit("afterLoadData");
            me.calcolaTotale();
            this.$refs.mdlTeamsystemintegrator.show();
        },
        loadDataError(error) {
            error;
            this.$emit("afterLoadData");
        },
        calcolaTotale() {
            let me = this;
            me.totaleDocuemnto = 0;
            me.totaleVersato = 0;
            me.jsonDataFattura.Corpo.forEach((element) => {
                if (element.unitaMisura === "NR") {
                    me.totaleDocuemnto += parseFloat(String(element.importoTotale).replace(",", ".")) || 0;
                } else if (element.unitaMisura === "PG") {
                    me.totaleVersato += parseFloat(String(element.importoTotale).replace(",", ".")) || 0;
                }
            });
        },
        onOk() {},
    },
};
</script>

<style></style>
